import React, { FC, useState } from 'react';
import { Card as AntdCard, CardProps as AntdCardProps } from 'antd';
import styled from 'styled-components';

import { ArrowDownIcon } from '~/img';

export interface CardProps extends AntdCardProps {
  status?: string;
  expandable?: boolean;
}

const Card: FC<CardProps> = (props) => {
  const { className, status, bordered = false, extra, expandable, ...rest } = props;
  const [open, setOpen] = useState(false);
  const handleToggle: React.MouseEventHandler<HTMLSpanElement> = (e) => {
    e.stopPropagation();
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <StyledCard
      className={`${className || ''} status-border__${status}`}
      bordered={bordered}
      extra={
        expandable ? <ArrowDownIcon className="Card-ArrowDownIcon" onClick={handleToggle} /> : extra
      }
      expandable={expandable}
      open={open}
      {...rest}
    />
  );
};

interface UIProps extends AntdCardProps {
  open: boolean;
  expandable?: boolean;
}

const StyledCard = styled<FC<UIProps>>(AntdCard as any)`
  padding-bottom: 16px;
  .ant-card-head {
    border-bottom: unset;
    padding: 16px;
    font-size: 14px;
    padding-bottom: 0;
    .ant-card-head-title {
      padding: 0;
    }
    .ant-card-extra {
      padding: 0;
    }
  }
  .ant-card-body {
    display: ${({ open, expandable }) => (open ? undefined : expandable ? 'none' : undefined)};
    padding: 16px;
    padding-bottom: 0;
  }
  .Card-ArrowDownIcon {
    font-size: 20px;
    transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
    // transition: 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
    color: #ccc;
    padding: 16px;
    margin: -16px;
  }
`;

export default Card;
